import { render, staticRenderFns } from "./TopicStudyPhaseStat.vue?vue&type=template&id=17ae3367&scoped=true&"
import script from "./TopicStudyPhaseStat.vue?vue&type=script&lang=js&"
export * from "./TopicStudyPhaseStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ae3367",
  null
  
)

export default component.exports